/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SessionQuarantineReleaseRequestBody,
  SessionQuarantineReleaseRequestBody$Outbound,
  SessionQuarantineReleaseRequestBody$outboundSchema,
} from "../components/sessionquarantinereleaserequestbody.js";

export type ReleaseSessionQuarantineSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ReleaseSessionQuarantineSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ReleaseSessionQuarantineSecurity = {
  option1?: ReleaseSessionQuarantineSecurityOption1 | undefined;
  option2?: ReleaseSessionQuarantineSecurityOption2 | undefined;
};

export type ReleaseSessionQuarantineRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  sessionQuarantineReleaseRequestBody: SessionQuarantineReleaseRequestBody;
};

/** @internal */
export type ReleaseSessionQuarantineSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ReleaseSessionQuarantineSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ReleaseSessionQuarantineSecurityOption1$Outbound,
    ReleaseSessionQuarantineSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function releaseSessionQuarantineSecurityOption1ToJSON(
  releaseSessionQuarantineSecurityOption1:
    ReleaseSessionQuarantineSecurityOption1,
): string {
  return JSON.stringify(
    ReleaseSessionQuarantineSecurityOption1$outboundSchema.parse(
      releaseSessionQuarantineSecurityOption1,
    ),
  );
}

/** @internal */
export type ReleaseSessionQuarantineSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ReleaseSessionQuarantineSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ReleaseSessionQuarantineSecurityOption2$Outbound,
    ReleaseSessionQuarantineSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function releaseSessionQuarantineSecurityOption2ToJSON(
  releaseSessionQuarantineSecurityOption2:
    ReleaseSessionQuarantineSecurityOption2,
): string {
  return JSON.stringify(
    ReleaseSessionQuarantineSecurityOption2$outboundSchema.parse(
      releaseSessionQuarantineSecurityOption2,
    ),
  );
}

/** @internal */
export type ReleaseSessionQuarantineSecurity$Outbound = {
  Option1?: ReleaseSessionQuarantineSecurityOption1$Outbound | undefined;
  Option2?: ReleaseSessionQuarantineSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ReleaseSessionQuarantineSecurity$outboundSchema: z.ZodMiniType<
  ReleaseSessionQuarantineSecurity$Outbound,
  ReleaseSessionQuarantineSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ReleaseSessionQuarantineSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ReleaseSessionQuarantineSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function releaseSessionQuarantineSecurityToJSON(
  releaseSessionQuarantineSecurity: ReleaseSessionQuarantineSecurity,
): string {
  return JSON.stringify(
    ReleaseSessionQuarantineSecurity$outboundSchema.parse(
      releaseSessionQuarantineSecurity,
    ),
  );
}

/** @internal */
export type ReleaseSessionQuarantineRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  SessionQuarantineReleaseRequestBody:
    SessionQuarantineReleaseRequestBody$Outbound;
};

/** @internal */
export const ReleaseSessionQuarantineRequest$outboundSchema: z.ZodMiniType<
  ReleaseSessionQuarantineRequest$Outbound,
  ReleaseSessionQuarantineRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    sessionQuarantineReleaseRequestBody:
      SessionQuarantineReleaseRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      sessionQuarantineReleaseRequestBody:
        "SessionQuarantineReleaseRequestBody",
    });
  }),
);

export function releaseSessionQuarantineRequestToJSON(
  releaseSessionQuarantineRequest: ReleaseSessionQuarantineRequest,
): string {
  return JSON.stringify(
    ReleaseSessionQuarantineRequest$outboundSchema.parse(
      releaseSessionQuarantineRequest,
    ),
  );
}
